module.exports = __webpack_public_path__ + "static/img/n4.c795f0ef.jpg";